import { Navigate } from 'react-router-dom';
import { getCookie } from './cookieUtils';
import { ACCESS_TOKEN } from './enums/misc';
import { FC, ReactNode } from 'react';
import { checkAccess } from './helpers';
import { PAGE_NOT_FOUND, USER } from 'constant/RoutesUrls';
import { RootState } from 'redux/store';
import { useSelector } from 'react-redux';

interface Props {
  children: ReactNode;
  redirectTo: string;
}

export const RequireAuth: FC<Props> = ({ children, redirectTo }) => {
  const isAuthenticated: boolean = !!getCookie(ACCESS_TOKEN);
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={{ pathname: redirectTo }} />
  );
};

export const OnlyPublicAuth: FC<Props> = ({ children, redirectTo }) => {
  const isAuthenticated: boolean = !!getCookie(ACCESS_TOKEN);
  return !isAuthenticated ? (
    children
  ) : (
    <Navigate to={{ pathname: redirectTo }} />
  );
};

export const PermissionBasedRoute = ({
  permissionsNeeded,
  children
}: {
  permissionsNeeded: string[];
  children: ReactNode;
}) => {
  const permission = useSelector(
    (state: RootState) => state.userProfile.permission
  );
  const findPermissionModule = (permissionsNeeded: string[]) => {
    if (permissionsNeeded.length === 0) {
      return PAGE_NOT_FOUND;
    }
    const firstPermission = permissionsNeeded[0];
    const permissionModule = firstPermission.split('.')[0];
    return permissionModule;
  };
  const permissionModule = findPermissionModule(permission);
  if (checkAccess(permissionsNeeded, permission)) {
    return children;
  } else {
    return <Navigate to={{ pathname: permissionModule }} />;
  }
};
